import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";

const LoadingButton = (props: { loading: boolean } & any) => {
  const { loading } = props;
  const { t } = useTranslation("components");

  return (
    <Button
      loadingPosition="start"
      loading={props.loading}
      {...props}
      sx={{
        ...props.sx,
        ...(loading && {
          textTransform: "none",
          fontSize: "14px",
        }),
      }}
    >
      {loading ? t("buttonLabels.gettingGps") : props.children}
    </Button>
  );
};

export default LoadingButton;
